import { tl } from 'common/services/i18nService';
import { HitPrefix } from 'common/store/common/search/types';

const AI_ASSISTED_MARKING_MPP = 'ENABLE_AI_ASSISTED_MARKING';

export const AI_ELIGIBLE_COLUMN_REF = 'enableAiAssistedMarking';
export const AI_ELIGIBLE_COLUMN_LABEL = 'Ai Eligible';

export const isAiMarkingMarketplaceEnabled = (): boolean => (
    Boolean(window.marketplaceProperties?.[AI_ASSISTED_MARKING_MPP])
);

export const isQuestionAiEligible = (hit?: { enableAiAssistedMarking?: boolean } | null): boolean => (
    hit?.enableAiAssistedMarking === true
);

export const getColumnHeaderLabel = (columnRef?: string): string => (
    tl(
        `${HitPrefix.COLUMN}${columnRef}`,
        {},
        columnRef === AI_ELIGIBLE_COLUMN_REF ? AI_ELIGIBLE_COLUMN_LABEL : undefined
    )
);

export const removeAiEligibleColumn = <T extends { ref?: string }>(items: T[]): T[] => (
    items.filter((item) => item.ref !== AI_ELIGIBLE_COLUMN_REF)
);

export const withoutAiEligibleWhenDisabled = <T extends { ref?: string }>(items: T[]): T[] => (
    isAiMarkingMarketplaceEnabled() ? items : removeAiEligibleColumn(items)
);
